import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "../../components/common/AppNavbar";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Source+Serif+4:ital,wght@0,400;0,500;1,400&display=swap');

  .srk-page {
    background: #FAFAF8;
    min-height: 100vh;
    font-family: 'Source Serif 4', Georgia, serif;
    color: #1C1C1C;
  }

  .srk-hero-bar {
    background: linear-gradient(90deg, #7B2D00 0%, #B84500 60%, #C8720A 100%);
    height: 5px;
    width: 100%;
  }

  .srk-header h2 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.3;
    color: #1C1C1C;
  }

  .srk-badge {
    background: #FFF3E0 !important;
    color: #B84500 !important;
    border: 1px solid #F0A060;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: 3px;
  }

  .srk-dateline {
    font-size: 0.9rem;
    color: #888;
    letter-spacing: 0.5px;
    border-left: 3px solid #C8720A;
    padding-left: 10px;
    margin-top: 8px;
    display: inline-block;
  }

  .srk-divider {
    border: none;
    border-top: 1px solid #E8E0D0;
    margin: 28px 0;
  }

  .srk-video-wrapper {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  }

  .srk-body p {
    font-size: 1.05rem;
    line-height: 1.85;
    color: #333;
    margin-bottom: 18px;
  }

  .srk-section-title {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.35rem;
    font-weight: 700;
    color: #1C1C1C;
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 18px;
  }

  .srk-section-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #B84500, #C8720A);
    border-radius: 2px;
  }

  .srk-card {
    border: 1px solid #E8E0D0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
    background: #fff !important;
  }

  .srk-card .card-body {
    padding: 28px 32px;
  }

  .srk-card h3,
  .srk-card h4 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1C1C1C;
    margin-bottom: 14px;
  }

  .srk-card h5 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1rem;
    font-weight: 600;
    color: #B84500;
    margin-bottom: 10px;
  }

  .srk-card ul, .srk-card ol {
    padding-left: 20px;
    color: #444;
    font-size: 0.97rem;
    line-height: 1.8;
  }

  .srk-card p {
    font-size: 0.97rem;
    line-height: 1.8;
    color: #444;
    margin-bottom: 10px;
  }

  .srk-closing-bold {
    font-size: 1.05rem;
    font-weight: 600;
    color: #B84500;
    border-left: 3px solid #C8720A;
    padding-left: 16px;
    font-style: italic;
  }

  .srk-about-card {
    background: linear-gradient(135deg, #1C1C1C 0%, #2E1A06 100%) !important;
    border: none !important;
    border-radius: 8px !important;
  }

  .srk-about-card .card-body { padding: 28px 32px; }

  .srk-about-card h4 {
    font-family: 'Playfair Display', Georgia, serif;
    font-size: 1.2rem;
    color: #F0C040;
    margin-bottom: 8px;
  }

  .srk-about-card .about-link {
    color: #F0A060;
    font-size: 0.88rem;
    font-weight: 600;
    text-decoration: none;
    letter-spacing: 0.3px;
  }

  .srk-about-card .about-link:hover { color: #fff; }

  .srk-about-card p {
    color: rgba(255,255,255,0.7);
    font-size: 0.95rem;
    line-height: 1.75;
    margin-bottom: 14px;
  }

  .srk-ad-label {
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #aaa;
    margin-bottom: 6px;
  }

  .srk-ad-img {
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.08);
    max-height: 180px;
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    .srk-header h2 { font-size: 1.5rem; }
    .srk-card .card-body { padding: 20px; }
  }
`;

function SriRamaKalyanamEvent() {
  return (
    <>
      <style>{styles}</style>
      <AppNavbar />

      <div className="srk-page">
        <div className="srk-hero-bar" />

        <div className="container py-5">
          {/* Header */}
          <div className="srk-header mb-4">
            <span className="badge srk-badge mb-3">Past Event</span>
            <h2>
              Bharat Abroad Celebrates Sri Rama Kalyanam Organized by JET USA in
              Michigan
            </h2>
            <div className="srk-dateline">March 29, 2026 — Novi, Michigan</div>
          </div>

          <hr className="srk-divider" />

          {/* Video */}
          <div className="mb-5">
            <div className="srk-video-wrapper ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/qtfEERp6f2k"
                title="Sri Rama Kalyanam — JET USA Michigan"
                allowFullScreen
              />
            </div>
          </div>

          {/* Intro */}
          <div className="srk-body mb-4">
            <p>
              Bharat Abroad proudly joined the local Bharatiya community in
              Novi, Michigan, to witness and celebrate{" "}
              <strong>Sri Rama Kalyanam</strong>, a sacred Hindu ceremony
              organized by{" "}
              <strong>JET USA (Jeeyar Educational Trust USA)</strong>. The event
              brought together devotees, families, and youth to participate in
              one of Bharat's most revered spiritual traditions, fostering
              devotion and cultural continuity within the global diaspora.
            </p>
            <p>
              Sri Rama Kalyanam, symbolizing the divine marriage of Lord Rama
              and Goddess Sita, was conducted in accordance with traditional
              Vedic rituals, accompanied by mantra chanting and devotional
              music. The ceremony created a deeply sanctified and serene
              atmosphere, reflecting the grandeur of temple celebrations across
              Bharat.
            </p>
          </div>

          {/* Section 1 */}
          <div className="srk-body mb-4">
            <h3 className="srk-section-title">
              A Sacred Ceremony Rooted in Tradition
            </h3>
            <p>
              With meticulous attention to tradition, priests and volunteers
              guided devotees through each ritual with reverence and clarity.
              Floral decorations, sacred offerings, and beautifully adorned
              deities enhanced the spiritual ambiance, evoking a profound sense
              of <em>bhakti</em> among attendees.
            </p>
            <p>
              The atmosphere was deeply sanctified and serene, reflecting the
              grandeur of temple celebrations across Bharat and bringing a piece
              of that heritage to the heart of Michigan.
            </p>
          </div>

          {/* Section 2 */}
          <div className="srk-body mb-4">
            <h3 className="srk-section-title">
              Bridging Generations Through Living Tradition
            </h3>
            <p>
              JET USA continues to play a vital role in preserving and
              transmitting Bharatiya spiritual heritage abroad through its
              spiritual, educational, and cultural initiatives. Events such as
              Sri Rama Kalyanam serve as a meaningful bridge between
              generations, allowing children, youth, and elders to engage with
              tradition through lived experience.
            </p>
            <p>
              Bharat Abroad engaged with organizers and participants throughout
              the event, observing how such sacred gatherings strengthen
              community bonds and reaffirm that Bharat's spiritual heritage
              thrives far beyond its geographical boundaries.
            </p>
          </div>

          {/* About JET USA Card */}
          <div className="card srk-card mb-4">
            <div className="card-body">
              <h3>About JET USA</h3>
              <p>
                JET USA (Jeeyar Educational Trust USA) is dedicated to
                preserving and promoting Bharatiya spiritual and cultural
                heritage across the global diaspora. Their initiatives include:
              </p>
              <ul>
                <li>Traditional Vedic ceremonies and rituals</li>
                <li>Spiritual education programs for youth and families</li>
                <li>
                  Cultural events that connect communities across generations
                </li>
                <li>
                  Outreach to Bharatiya communities throughout North America
                </li>
              </ul>
              <h5 className="mt-3">Their Mission</h5>
              <ol>
                <li>Preserving authentic Vedic traditions outside Bharat</li>
                <li>Educating the next generation in spiritual heritage</li>
                <li>Fostering community and devotion among the diaspora</li>
              </ol>
            </div>
          </div>

          {/* Closing */}
          <div className="srk-body mb-5">
            <h3 className="srk-section-title">
              Heritage That Transcends Borders
            </h3>
            <p>
              The presence of organizations like JET USA highlights the enduring
              vitality of Bharat's spiritual traditions within global
              communities. Their dedication allows Bharatiya families abroad to
              stay deeply connected with their roots while nurturing the next
              generation in the same timeless values.
            </p>
            <p className="srk-closing-bold">
              Bharat Abroad remains honored to support and highlight initiatives
              like Sri Rama Kalyanam that keep Bharat's timeless traditions
              vibrant and alive wherever Bharatiya communities reside.
            </p>
          </div>

          {/* About Bharat Abroad */}
          <div className="card srk-about-card mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                {/* Left Image */}
                <div className="col-md-3 text-center mb-3 mb-md-0">
                  <img
                    src="https://ayg.s3.us-east-2.amazonaws.com/BA_whatsapp.png"
                    alt="Bharat Abroad"
                    className="img-fluid rounded"
                    style={{ height: "auto" }}
                  />
                </div>

                {/* Right Content */}
                <div className="col-md-9">
                  <h4>About Bharat Abroad</h4>

                  <p className="mb-2">
                    <a
                      href="https://chat.whatsapp.com/LNfGI3UFWbt69VeUbBoxLj"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="about-link"
                    >
                      www.bharatabroad.com
                    </a>{" "}
                    — Subscribe with us / Join our WhatsApp Community
                  </p>

                  <p className="mb-0">
                    Bharat Abroad is a community-focused initiative dedicated to
                    highlighting and strengthening Bharat's cultural and
                    spiritual presence across the global diaspora through
                    storytelling, event engagement, and collaboration with
                    nonresident Bharatiya organizations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SriRamaKalyanamEvent;
